exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-preview[data-v-64e05884] {\n  width: 68px;\n  height: 68px;\n  min-width: 68px;\n  min-height: 68px;\n  margin-right: 1rem;\n  padding: 3px;\n}\n.img-preview img[data-v-64e05884] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
